<template>
	<div>
		<!-- 第一列 -->
		<el-form class="left" ref="defForm" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="招聘岗位" prop="name">
				<el-input v-model="defForm.name" placeholder="请输入岗位名称"></el-input>
			</el-form-item>
			<el-form-item label="招聘类型" prop="type">
				<el-select v-model="defForm.type" placeholder="请选择类型" filterable   >
					<el-option
						v-for="item in typeList"
						:key="item.label"
						:label="item.label"
						:value="item.label">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="地址" prop="address">
				<!-- <el-input v-model="defForm.address" placeholder="请输入地址"></el-input> -->
				
				<el-select v-model="defForm.address" placeholder="请选择地址" filterable   >
					<el-option
						v-for="item in ['上海','唐山','西安','太原','郑州','海口',]"
						:key="item"
						:label="item"
						:value="item">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<!-- 第二列 -->
		<el-form class="right" ref="defForm2" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="邮箱" prop="email">
				<el-input v-model="defForm.email" placeholder="请输入邮箱"></el-input>
			</el-form-item>
			<el-form-item label="人数" prop="number">
				<el-input type="number" v-model="defForm.number" placeholder="请输入人数"></el-input>
			</el-form-item>
			<el-form-item label="发布时间" prop="publish">
				<el-date-picker
					v-model="defForm.publish" 
					type="date" 
					value-format="yyyy-MM-dd"
					placeholder="请输入发布日期" >
				</el-date-picker>
			</el-form-item>
		</el-form>
		<!-- 编辑器 -->
		<el-form ref="defForm" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="岗位介绍" prop="content">
				<el-input type="textarea" v-model="defForm.content" :show-word-limit="true" maxlength="500" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="岗位职责" prop="responsibility">
				<el-input type="textarea" v-model="defForm.responsibility" :show-word-limit="true" maxlength="1000" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="任职资格" prop="qualification">
				<el-input type="textarea" v-model="defForm.qualification" :show-word-limit="true" maxlength="1000" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
		</el-form>
		<!-- 按钮部分 -->
		<div class="button" style="margin-left: 100px;">
			<el-button type="primary" @click="$router.back()">返回</el-button>
			<el-button type="primary" :loading="loading" @click="submitForm(defForm)">保存</el-button>
		</div>
	</div>
</template>
<script>
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	import {update,upload,detail} from '@/api/joinUs'
	import {queryTreeChannelByPid} from '@/api/channel'
	import token from '@/token.js'
	export default {
		name: "Add",
		data() {
			return {
				typeList:[],
				defForm: {
					id:0,
					name: '',
					email:'',
					type: '',
					address: '',
					number: '',
					content: '',
					responsibility: '',
					qualification: '',
					publish: '',
					updateUserID: token.getUser().id,
					updateUserName: token.getUser().manager_username
				},
				treeData: [],
				loading: false,
				rules: {
					name: [{
						required: true,
						message: '必填项不能为空'
					}],
					type: [{
						required: true,
						message: '必填项不能为空'
					}],
				}
			}
		},

		created() {
			let obj = this.$route.query.obj
			console.log(obj)
			this.defForm.id=obj.id,
			this.defForm.name=obj.name,
			this.defForm.email=obj.email,
			this.defForm.type=obj.type,
			this.defForm.address=obj.address,
			this.defForm.number=obj.number,
			this.defForm.content=obj.content,
			this.defForm.responsibility=obj.responsibility,
			this.defForm.qualification=obj.qualification,
			this.defForm.publish=obj.publish;
			queryTreeChannelByPid(12).then(data => {
				this.typeList = data.data
			}).catch(error => {
				this.$message.error(error)
			})
		},
		methods: {
			submitForm(form) {
				this.$refs['defForm'].validate(valid => {
					if (valid) {
						this.loading = true
						
						// console.log("新增",this.defForm)
						update(this.defForm).then(data => {
							this.loading = false
							this.$refs['defForm'].resetFields()
							this.$message.success("编辑成功!")
							this.$router.push('/admin/joinUs/joinUsindex')
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			},
			close() {
				this.$emit("hideDialog")
			},
		}
	}
</script>

<style scoped>
	div ::v-deep .el-date-editor{
		width: 100%;
	}
	div ::v-deep .el-select{
		width: 100%;
	}
	.left{
		width: 50%;
		display: inline-block;
	}
	.right{
		width: 50%;
		display: inline-block;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		width: 80px;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}
</style>
